/* ============================================================
   RAL color variant picker — enhancement layer
   Built 2026-06-12. Watches for any variant fieldset whose option
   name is Farbe / Color / Colour and whose values match RAL XXXX.
   Renders an interactive swatch grid using official RAL Classic
   hex codes and German names. The original Shopify radio inputs
   stay in the DOM (hidden) so form submission + Shopify's
   variant-radios web component continue to work.
   ============================================================ */
(function () {
  'use strict';

  // Official RAL Classic colors. Source: RAL gGmbH publications + DIN 6164.
  // Key = numeric code (without "RAL " prefix). Value = [hex, German name].
  var RAL = {
    "1000":["#BEBD7F","Gr&uuml;nbeige"],"1001":["#C2B078","Beige"],"1002":["#C6A664","Sandgelb"],
    "1003":["#E5BE01","Signalgelb"],"1004":["#CDA434","Goldgelb"],"1005":["#A98307","Honiggelb"],
    "1006":["#E4A010","Maisgelb"],"1007":["#DC9D00","Narzissengelb"],"1011":["#8A6642","Braunbeige"],
    "1012":["#C7B446","Zitronengelb"],"1013":["#EAE6CA","Perlwei&szlig;"],"1014":["#E1CC4F","Elfenbein"],
    "1015":["#E6D690","Hellelfenbein"],"1016":["#EDFF21","Schwefelgelb"],"1017":["#F5D033","Safrangelb"],
    "1018":["#F8F32B","Zinkgelb"],"1019":["#9E9764","Graubeige"],"1020":["#999950","Olivgelb"],
    "1021":["#F3DA0B","Rapsgelb"],"1023":["#FAD201","Verkehrsgelb"],"1024":["#AEA04B","Ockergelb"],
    "1026":["#FFFF00","Leuchtgelb"],"1027":["#9D9101","Currygelb"],"1028":["#F4A900","Melonengelb"],
    "1032":["#D6AE01","Ginstergelb"],"1033":["#F3A505","Dahliengelb"],"1034":["#EFA94A","Pastellgelb"],
    "1035":["#6A5D4D","Perlbeige"],"1036":["#705335","Perlgold"],"1037":["#F39F18","Sonnengelb"],
    "2000":["#ED760E","Gelborange"],"2001":["#C93C20","Rotorange"],"2002":["#CB2821","Blutorange"],
    "2003":["#FF7514","Pastellorange"],"2004":["#F44611","Reinorange"],"2005":["#FF2301","Leuchtorange"],
    "2007":["#FFA420","Leuchthellorange"],"2008":["#F75E25","Hellrotorange"],"2009":["#F54021","Verkehrsorange"],
    "2010":["#D84B20","Signalorange"],"2011":["#EC7C26","Tieforange"],"2012":["#E55137","Lachsorange"],
    "2013":["#C35831","Perlorange"],
    "3000":["#AF2B1E","Feuerrot"],"3001":["#A52019","Signalrot"],"3002":["#A2231D","Karminrot"],
    "3003":["#9B111E","Rubinrot"],"3004":["#75151E","Purpurrot"],"3005":["#5E2129","Weinrot"],
    "3007":["#412227","Schwarzrot"],"3009":["#642424","Oxidrot"],"3011":["#781F19","Braunrot"],
    "3012":["#C1876B","Beigerot"],"3013":["#A12312","Tomatenrot"],"3014":["#D36E70","Altrosa"],
    "3015":["#EA899A","Hellrosa"],"3016":["#B32821","Korallenrot"],"3017":["#E63244","Ros&eacute;"],
    "3018":["#D53032","Erdbeerrot"],"3020":["#CC0605","Verkehrsrot"],"3022":["#D95030","Lachsrot"],
    "3024":["#F80000","Leuchtrot"],"3026":["#FE0000","Leuchthellrot"],"3027":["#C51D34","Himbeerrot"],
    "3028":["#CB3234","Reinrot"],"3031":["#B32428","Orientrot"],"3032":["#721422","Perlrubinrot"],
    "3033":["#B44C43","Perlrosa"],
    "4001":["#6D3F5B","Rotlila"],"4002":["#922B3E","Rotviolett"],"4003":["#DE4C8A","Erikaviolett"],
    "4004":["#641C34","Bordeauxviolett"],"4005":["#6C4675","Blaulila"],"4006":["#A03472","Verkehrspurpur"],
    "4007":["#4A192C","Purpurviolett"],"4008":["#924E7D","Signalviolett"],"4009":["#A18594","Pastellviolett"],
    "4010":["#CF3476","Telemagenta"],"4011":["#8673A1","Perlviolett"],"4012":["#6C6874","Perlbrombeer"],
    "5000":["#354D73","Violettblau"],"5001":["#1F3438","Gr&uuml;nblau"],"5002":["#20214F","Ultramarinblau"],
    "5003":["#1D1E33","Saphirblau"],"5004":["#18171C","Schwarzblau"],"5005":["#1E2460","Signalblau"],
    "5007":["#3E5F8A","Brillantblau"],"5008":["#26252D","Graublau"],"5009":["#025669","Azurblau"],
    "5010":["#0E294B","Enzianblau"],"5011":["#231A24","Stahlblau"],"5012":["#3B83BD","Lichtblau"],
    "5013":["#1E213D","Kobaltblau"],"5014":["#606E8C","Taubenblau"],"5015":["#2271B3","Himmelblau"],
    "5017":["#063971","Verkehrsblau"],"5018":["#3F888F","T&uuml;rkisblau"],"5019":["#1B5583","Capriblau"],
    "5020":["#1D334A","Ozeanblau"],"5021":["#256D7B","Wasserblau"],"5022":["#252850","Nachtblau"],
    "5023":["#49678D","Fernblau"],"5024":["#5D9B9B","Pastellblau"],"5025":["#2A6478","Perlenzian"],
    "5026":["#102C54","Perlnachtblau"],
    "6000":["#316650","Patinagr&uuml;n"],"6001":["#287233","Smaragdgr&uuml;n"],"6002":["#2D572C","Laubgr&uuml;n"],
    "6003":["#424632","Olivgr&uuml;n"],"6004":["#1F3A3D","Blaugr&uuml;n"],"6005":["#2F4538","Moosgr&uuml;n"],
    "6006":["#3E3B32","Grauoliv"],"6007":["#343B29","Flaschengr&uuml;n"],"6008":["#39352A","Braungr&uuml;n"],
    "6009":["#31372B","Tannengr&uuml;n"],"6010":["#35682D","Grasgr&uuml;n"],"6011":["#587246","Resedagr&uuml;n"],
    "6012":["#343E40","Schwarzgr&uuml;n"],"6013":["#6C7156","Schilfgr&uuml;n"],"6014":["#47402E","Gelboliv"],
    "6015":["#3B3C36","Schwarzoliv"],"6016":["#1E5945","T&uuml;rkisgr&uuml;n"],"6017":["#4C9141","Maigr&uuml;n"],
    "6018":["#57A639","Gelbgr&uuml;n"],"6019":["#BDECB6","Wei&szlig;gr&uuml;n"],"6020":["#2E3A23","Chromoxidgr&uuml;n"],
    "6021":["#89AC76","Blassgr&uuml;n"],"6022":["#25221B","Braunoliv"],"6024":["#308446","Verkehrsgr&uuml;n"],
    "6025":["#3D642D","Farngr&uuml;n"],"6026":["#015D52","Opalgr&uuml;n"],"6027":["#84C3BE","Lichtgr&uuml;n"],
    "6028":["#2C5545","Kieferngr&uuml;n"],"6029":["#20603D","Minzgr&uuml;n"],"6032":["#317F43","Signalgr&uuml;n"],
    "6033":["#497E76","Minttuerkis"],"6034":["#7FB5B5","Pastellt&uuml;rkis"],"6035":["#1C542D","Perlgr&uuml;n"],
    "6036":["#193737","Perlopalgr&uuml;n"],"6037":["#008F39","Reingr&uuml;n"],"6038":["#00BB2D","Leuchtgr&uuml;n"],
    "7000":["#78858B","Fehgrau"],"7001":["#8A9597","Silbergrau"],"7002":["#7E7B52","Olivgrau"],
    "7003":["#6C7059","Moosgrau"],"7004":["#969992","Signalgrau"],"7005":["#646B63","Mausgrau"],
    "7006":["#6D6552","Beigegrau"],"7008":["#6A5F31","Khakigrau"],"7009":["#4D5645","Gr&uuml;ngrau"],
    "7010":["#4C514A","Zeltgrau"],"7011":["#434B4D","Eisengrau"],"7012":["#4E5754","Basaltgrau"],
    "7013":["#464531","Braungrau"],"7015":["#434750","Schiefergrau"],"7016":["#293133","Anthrazitgrau"],
    "7021":["#23282B","Schwarzgrau"],"7022":["#332F2C","Umbragrau"],"7023":["#686C5E","Betongrau"],
    "7024":["#474A51","Graphitgrau"],"7026":["#2F353B","Granitgrau"],"7030":["#8B8C7A","Steingrau"],
    "7031":["#474B4E","Blaugrau"],"7032":["#B8B799","Kieselgrau"],"7033":["#7D8471","Zementgrau"],
    "7034":["#8F8B66","Gelbgrau"],"7035":["#D7D7D7","Lichtgrau"],"7036":["#7F7679","Platingrau"],
    "7037":["#7D7F7D","Staubgrau"],"7038":["#B5B8B1","Achatgrau"],"7039":["#6C6960","Quarzgrau"],
    "7040":["#9DA1AA","Fenstergrau"],"7042":["#8D948D","Verkehrsgrau A"],"7043":["#4E5452","Verkehrsgrau B"],
    "7044":["#CAC4B0","Seidengrau"],"7045":["#909090","Telegrau 1"],"7046":["#82898F","Telegrau 2"],
    "7047":["#D0D0D0","Telegrau 4"],"7048":["#898176","Perlmausgrau"],
    "8000":["#826C34","Gr&uuml;nbraun"],"8001":["#955F20","Ockerbraun"],"8002":["#6C3B2A","Signalbraun"],
    "8003":["#734222","Lehmbraun"],"8004":["#8E402A","Kupferbraun"],"8007":["#59351F","Rehbraun"],
    "8008":["#6F4F28","Olivbraun"],"8011":["#5B3A29","Nussbraun"],"8012":["#592321","Rotbraun"],
    "8014":["#382C1E","Sepiabraun"],"8015":["#633A34","Kastanienbraun"],"8016":["#4C2F27","Mahagonibraun"],
    "8017":["#45322E","Schokoladenbraun"],"8019":["#403A3A","Graubraun"],"8022":["#212121","Schwarzbraun"],
    "8023":["#A65E2E","Orangebraun"],"8024":["#79553D","Beigebraun"],"8025":["#755C48","Blassbraun"],
    "8028":["#4E3B31","Terrabraun"],"8029":["#763C28","Perlkupfer"],
    "9001":["#FDF4E3","Cremewei&szlig;"],"9002":["#E7EBDA","Grauwei&szlig;"],"9003":["#F4F4F4","Signalwei&szlig;"],
    "9004":["#282828","Signalschwarz"],"9005":["#0A0A0A","Tiefschwarz"],"9006":["#A5A5A5","Wei&szlig;aluminium"],
    "9007":["#8F8F8F","Graualuminium"],"9010":["#FFFFFF","Reinwei&szlig;"],"9011":["#1C1C1C","Graphitschwarz"],
    "9016":["#F6F6F6","Verkehrswei&szlig;"],"9017":["#1E1E1E","Verkehrsschwarz"],"9018":["#D7D7D7","Papyruswei&szlig;"],
    "9022":["#9C9C9C","Perlhellgrau"],"9023":["#828282","Perldunkelgrau"]
  };

  // Decode HTML entities since the Liquid above stores them
  function dec(s) {
    return s.replace(/&uuml;/g,"ü").replace(/&ouml;/g,"ö").replace(/&auml;/g,"ä")
            .replace(/&Uuml;/g,"Ü").replace(/&Ouml;/g,"Ö").replace(/&Auml;/g,"Ä")
            .replace(/&szlig;/g,"ß");
  }

  // Relative luminance, to decide whether the code label inside the swatch should be light or dark
  function isDark(hex) {
    var c = hex.replace('#','');
    var r = parseInt(c.substr(0,2),16), g = parseInt(c.substr(2,2),16), b = parseInt(c.substr(4,2),16);
    var lum = (0.299*r + 0.587*g + 0.114*b) / 255;
    return lum < 0.55;
  }

  // Extract numeric RAL code from a label value like "RAL 7015" or "ral-7015"
  function getRalCode(value) {
    if (!value) return null;
    var m = String(value).match(/RAL[\s\-_]?(\d{4})/i);
    return m ? m[1] : null;
  }

  function isRalOptionName(name) {
    var n = (name || '').trim().toLowerCase();
    return n === 'farbe' || n === 'color' || n === 'colour' || n === 'farbton';
  }

  function buildHeader(fieldset, selectedRal) {
    var header = document.createElement('div');
    header.className = 'ral-picker__header';

    var legend = fieldset.querySelector('legend');
    var legendName = legend ? legend.firstChild && legend.firstChild.textContent.trim() : 'Farbe';
    legendName = legendName.replace(/:\s*$/,'');

    var selName = document.createElement('div');
    selName.className = 'ral-picker__selected-name';
    selName.innerHTML = '<span class="ral-picker__selected-label">'+ legendName +':</span> <strong class="ral-picker__selected-value">RAL '+ selectedRal +'</strong>'
      + (RAL[selectedRal] ? ' <span class="ral-picker__selected-german">— '+ dec(RAL[selectedRal][1]) +'</span>' : '');
    header.appendChild(selName);

    var search = document.createElement('div');
    search.className = 'ral-picker__search';
    search.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/><path d="m20 20-3.5-3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
      + '<input type="search" placeholder="RAL-Code oder Name…" autocomplete="off" inputmode="search">';
    header.appendChild(search);

    return { el: header, selValueEl: selName.querySelector('.ral-picker__selected-value'), selGermanEl: selName.querySelector('.ral-picker__selected-german'), searchInput: search.querySelector('input') };
  }

  function buildGrid(fieldset, radios) {
    var grid = document.createElement('div');
    grid.className = 'ral-picker__grid';
    grid.setAttribute('role','radiogroup');

    var swatches = [];
    radios.forEach(function (radio) {
      var ral = getRalCode(radio.value);
      if (!ral) return;
      var meta = RAL[ral];
      var hex = meta ? meta[0] : '#cccccc';
      var name = meta ? dec(meta[1]) : 'Unbekannt';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ral-picker__swatch';
      btn.style.setProperty('--ral-color', hex);
      btn.setAttribute('data-ral', ral);
      btn.setAttribute('data-ral-name', 'RAL '+ ral +' · '+ name);
      btn.setAttribute('data-search', (ral + ' ' + name).toLowerCase());
      btn.setAttribute('data-luminance', isDark(hex) ? 'dark' : 'light');
      btn.setAttribute('aria-label', 'RAL '+ ral +' '+ name);
      if (radio.checked) btn.classList.add('is-selected');
      // Only the actual `disabled` HTML attribute is trusted. The theme's
      // Liquid markup mistakenly adds class='disabled' to every radio (its
      // option_disabled calculation references an out-of-scope `value`) and
      // class='unavailable' from the currently-selected variant — both are
      // false-positives. Shopify's variant-radios web component sets the real
      // .disabled attribute at runtime for truly unavailable variants.
      if (radio.disabled) btn.classList.add('is-unavailable');

      var code = document.createElement('span');
      code.className = 'ral-picker__swatch-code';
      code.textContent = ral;
      btn.appendChild(code);

      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        radio.checked = true;
        // Trigger Shopify's variant-radios listener (it watches change on the inputs)
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      });

      grid.appendChild(btn);
      swatches.push(btn);
    });

    return { el: grid, swatches: swatches };
  }

  function enhance(fieldset) {
    if (fieldset.dataset.ralEnhanced) return;
    var legend = fieldset.querySelector('legend');
    if (!legend) return;
    var legendText = (legend.textContent || '').trim().split(':')[0].trim();
    if (!isRalOptionName(legendText)) return;

    var radios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    var ralRadios = radios.filter(function (r) { return getRalCode(r.value); });
    if (ralRadios.length < 3) return; // Not really a RAL picker

    fieldset.dataset.ralEnhanced = '1';
    fieldset.classList.add('ral-picker-host');

    var wrap = document.createElement('div');
    wrap.className = 'ral-picker';

    var selectedRadio = ralRadios.find(function (r) { return r.checked; }) || ralRadios[0];
    var selectedRal = getRalCode(selectedRadio.value);

    var header = buildHeader(fieldset, selectedRal);
    var grid = buildGrid(fieldset, ralRadios);

    wrap.appendChild(header.el);
    wrap.appendChild(grid.el);

    // Add a "no matches" empty state element (hidden until filter has no hits)
    var emptyEl = document.createElement('div');
    emptyEl.className = 'ral-picker__empty';
    emptyEl.textContent = 'Keine passenden Farbtöne gefunden.';
    emptyEl.style.display = 'none';
    grid.el.appendChild(emptyEl);

    // Insert the new UI before the original swatch group (which is now hidden via CSS)
    var insertAfter = fieldset.querySelector('.swatch-label-text');
    if (insertAfter) insertAfter.parentNode.insertBefore(wrap, insertAfter.nextSibling);
    else fieldset.appendChild(wrap);

    // Search/filter
    header.searchInput.addEventListener('input', function (e) {
      var q = (e.target.value || '').trim().toLowerCase();
      var visible = 0;
      grid.swatches.forEach(function (sw) {
        var match = !q || sw.getAttribute('data-search').indexOf(q) !== -1;
        sw.classList.toggle('is-hidden', !match);
        if (match) visible++;
      });
      emptyEl.style.display = visible === 0 ? 'block' : 'none';
    });

    // Reflect external variant changes (e.g. from URL, deeplink, or the back/forward buttons) back into our swatches
    ralRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var newRal = getRalCode(r.value);
        if (!newRal) return;
        grid.swatches.forEach(function (sw) {
          sw.classList.toggle('is-selected', sw.getAttribute('data-ral') === newRal);
        });
        header.selValueEl.textContent = 'RAL '+ newRal;
        if (RAL[newRal]) header.selGermanEl.textContent = '— '+ dec(RAL[newRal][1]);
        else header.selGermanEl.textContent = '';
      });
    });

    // Observe attribute changes on the radios — Shopify's variant-radios web
    // component toggles the `disabled` attribute as the user picks options.
    // Keep our swatches in sync so customers see what's actually buyable.
    if (window.MutationObserver) {
      var radioObserver = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.attributeName !== 'disabled') return;
          var radio = m.target;
          var ral = getRalCode(radio.value);
          if (!ral) return;
          var sw = grid.swatches.find(function (s) { return s.getAttribute('data-ral') === ral; });
          if (sw) sw.classList.toggle('is-unavailable', radio.disabled);
        });
      });
      ralRadios.forEach(function (r) {
        radioObserver.observe(r, { attributes: true, attributeFilter: ['disabled'] });
      });
    }
  }

  function scan() {
    document.querySelectorAll('fieldset.product-form__input').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Watch for ajax-replaced fieldsets (e.g. when Shopify swaps the variant section after a variant change)
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      var needsScan = false;
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (n.matches && n.matches('fieldset.product-form__input') || n.querySelector && n.querySelector('fieldset.product-form__input'))) needsScan = true;
        });
      });
      if (needsScan) scan();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
